import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ic-remove_fd344fd7fe9e95a125ef93363224025d",
  "use": "ic-remove_fd344fd7fe9e95a125ef93363224025d-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ic-remove_fd344fd7fe9e95a125ef93363224025d\">\n<circle cx=\"12\" cy=\"12\" r=\"11.5\" stroke=\"#C90000\" />\n<path d=\"M19 13H5V11H19V13Z\" fill=\"#C90000\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol